import { render, staticRenderFns } from "./AuditLogHeader.vue?vue&type=template&id=0f78b33c&"
import script from "./AuditLogHeader.vue?vue&type=script&lang=js&"
export * from "./AuditLogHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports